export default {
    listagem: {
        titulo_pagina: 'Lista de Estados',
        novo: 'Adicionar novo Estado',
        table: {
            empty: "Nenhum Estado encontrado",
            editar: "Editar",
            nome: "Nome"
        },
        filtro: {
            nome: "Nome"
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Estado',
            editar: 'Editar Estado'
        },
        fields: {
            nome: {
                label: 'Nome',
                description: 'Nome do Estado'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Estado'
            },
            botao_salvar : 'Salvar Estado'
        },
        create: {
            success: "Estado criado com Sucesso!",
            error: "Error ao criar Estado!"
        },
        update: {
            success: "Estado editado com Sucesso!",
            error: "Error ao editar Estado!"
        }
    }
}
